import React, { FC } from 'react';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import AppsIcon from '@material-ui/icons/Apps';
import ListIcon from '@material-ui/icons/List';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  group: {
    backgroundColor: 'transparent'
  }
});

interface ViewTypeSelectionProps {
  viewType: string;
  onChange: (view: string) => void;
}

const ViewTypeSelection: FC<ViewTypeSelectionProps> = ({
  viewType,
  onChange
}: ViewTypeSelectionProps) => {
  const classes = useStyles();

  return (
    <ToggleButtonGroup
      className={classes.group}
      value={viewType}
      exclusive
      onChange={(_, value) => onChange(value)}
      aria-label="pickup delivery dine-in"
    >
      <ToggleButton value="list" aria-label="display list">
        <ListIcon></ListIcon>
      </ToggleButton>
      <ToggleButton value="grid" aria-label="display grid">
        <AppsIcon></AppsIcon>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewTypeSelection;
